const DashboardCards = ({
    title,
    numbers,
    color,
}: {
    title: string;
    numbers: number;
    color?: string;
}) => {
    return (
        <div className="w-6/12 md:w-3/12 px-2">
            <div className="w-full border border-[#6366F1] rounded-2xl p-5">
                <h5 className={'text-sm font-semibold mb-2'} style={{ color }}>
                    {title}
                </h5>
                <h3 className="text-xl md:text-4xl font-bold text-gray-800 tracking-normal dark:text-white">
                    {new Intl.NumberFormat('en-GB', {
                        maximumSignificantDigits: 3,
                    }).format(numbers)}
                </h3>
            </div>
        </div>
    );
};

export default DashboardCards;
